import './styles.css';

// Minimal JS just to show bundling works
console.log('Holding page loaded');

